import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { BrnDialog, provideBrnDialogDefaultOptions } from '@spartan-ng/brain/dialog';
import { BrnSheet } from '@spartan-ng/brain/sheet';
import { HlmSheetOverlay } from './hlm-sheet-overlay';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'hlmSheet',
    imports: [HlmSheetOverlay],
    providers: [
        {
            provide: BrnDialog,
            useExisting: forwardRef(() => BrnSheet),
        },
        {
            provide: BrnSheet,
            useExisting: forwardRef(() => HlmSheet),
        },
        provideBrnDialogDefaultOptions({
            // add custom options here
        }),
    ],
    selector: 'hlm-sheet',
    template: `
        <hlm-sheet-overlay />
        <ng-content />
    `,
})
export class HlmSheet extends BrnSheet {}
